import SiteNav from '@/components/SiteNav';
import SiteFooter from '@/components/SiteFooter';
import HeroFilm from '@/components/HeroFilm';
import MissionPanel from '@/pages/home/components/MissionPanel';
import ManifestoPanel from '@/pages/home/components/ManifestoPanel';
import ApproachPanel from '@/pages/home/components/ApproachPanel';
import PrinciplesPanel from '@/pages/home/components/PrinciplesPanel';
import ContactPanel from '@/pages/home/components/ContactPanel';
import FaqSection from '@/pages/home/components/FaqSection';

export default function Home() {
  return (
    <div className="min-h-screen bg-[#29251f]">
      <SiteNav />
      <main>
        <HeroFilm />
        <MissionPanel />
        <ManifestoPanel />
        <ApproachPanel />
        <PrinciplesPanel />
        <ContactPanel />
        <FaqSection />
      </main>
      <SiteFooter />
    </div>
  );
}